import React from 'react';
import axios from 'axios';

export default function DeleteProjectModal({ onClose, project, fetchProjects }) {
    const handleDelete = async () => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/projectRoutes/projects/${project.id}`);
            fetchProjects();
            onClose(); // Close modal after deletion
        } catch (error) {
            console.error('Erro ao excluir projeto:', error);
            alert('Não foi possível excluir o projeto. Tente novamente.');
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-96">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Excluir Projeto</h2>
                <p className="mb-4">Tem certeza de que deseja excluir o projeto {project.nome}?</p>
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={handleDelete}
                        className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
                    >
                        Excluir
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-red-500 text-white py-1 px-3 rounded-md hover:bg-red-600"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
}
